import React from 'react';
import TaskGrid from '../taskGrid';
import CalendarView from '../calendarView';
import TasksPage from '../taskPage';
import { TASK_LIST_TYPE } from '../../../../global/constants';

type TaskViewType = (typeof TASK_LIST_TYPE)[keyof typeof TASK_LIST_TYPE];

interface Props {
  taskViewType: TaskViewType;
  loading: boolean;
  loadData: () => void;
  hiddenTask: number;
  startOfTheWeek: Date;
}

const TaskViewSwitch = React.memo(function TaskViewSwitch({
  taskViewType,
  loading,
  loadData,
  hiddenTask,
  startOfTheWeek
}: Props) {
  if (taskViewType === TASK_LIST_TYPE.TASK_GRID) {
    return <TaskGrid propsLoading={loading} loadData={loadData} />;
  }

  if (taskViewType === TASK_LIST_TYPE.CALENDAR_VIEW) {
    return <CalendarView loadData={loadData} currentDate={startOfTheWeek} />;
  }

  return <TasksPage propsLoading={loading} loadData={loadData} hiddenTask={hiddenTask} />;
});

export default TaskViewSwitch;
